import type {
  Aggregations,
  FilterResult,
} from '@xing-com/crate-jobs-domain-search-types';

// Conversational search only supports a subset of filters
const removeUnavailable =
  () =>
  (filter: FilterResult | 'salary'): boolean =>
    filter === 'salary' || !!filter.isAiCompatible;

export const getFiltersFromAggregations = ({
  remoteOptions,
  employmentTypes,
  careerLevels,
}: Aggregations): Array<'salary' | FilterResult> =>
  (
    [
      {
        options: remoteOptions,
        titleKey: 'JOBS_SEARCH_FILTER_REMOTE_OPTION',
        name: 'remoteOption',
        isAiCompatible: true,
      },
      {
        options: employmentTypes,
        titleKey: 'JOBS_SEARCH_FILTER_EMPLOYMENT_TYPE',
        name: 'employmentType',
        isAiCompatible: true,
      },
      {
        options: careerLevels,
        titleKey: 'JOBS_SEARCH_FILTER_CAREER_LEVEL',
        name: 'careerLevel',
        isAiCompatible: true,
      },
      'salary',
    ] satisfies Array<'salary' | FilterResult>
  ).filter(removeUnavailable());
